var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-fuzzy',{attrs:{"param":_vm.param,"obj":_vm.obj},on:{"change":_vm.cb}})}
var staticRenderFns = []

export { render, staticRenderFns }